(function () {
  'use strict';

  var DESKTOP_ITEMS_PER_PAGE = 6; // 3 columns x 2 rows
  var MOBILE_ITEMS_PER_PAGE = 4; // 2 columns x 2 rows

  function initSplitScroll(section) {
    var viewport = section.querySelector('[data-split-scroll-viewport]');
    var track = section.querySelector('[data-split-scroll-track]');
    var items = Array.prototype.slice.call(section.querySelectorAll('[data-split-scroll-item]'));
    var currentEl = section.querySelector('[data-split-scroll-current]');
    var totalEl = section.querySelector('[data-split-scroll-total]');
    var prevBtn = section.querySelector('[data-split-scroll-prev]');
    var nextBtn = section.querySelector('[data-split-scroll-next]');

    if (!viewport || !track || !items.length) return;

    var gridCol = section.querySelector('.split-scroll__grid-col');
    var panelSticky = section.querySelector('.split-scroll__panel-sticky');

    function syncPanelHeight() {
      if (!gridCol || !panelSticky) return;
      if (window.innerWidth < 990) {
        section.style.removeProperty('--split-scroll-panel-height');
        return;
      }
      var h = gridCol.offsetHeight;
      if (h > 0) section.style.setProperty('--split-scroll-panel-height', h + 'px');
    }

    var pageCount = Math.max(Math.ceil(items.length / DESKTOP_ITEMS_PER_PAGE), 1);
    if (totalEl) totalEl.textContent = String(pageCount);

    var scrollTriggerInstance = null; // desktop (GSAP pin-driven)
    var mode = null; // 'desktop' | 'mobile'
    var activePage = 0;
    var mobileScrollTimeout = null;

    function setPageCountForMode(itemsPerPage) {
      pageCount = Math.max(Math.ceil(items.length / itemsPerPage), 1);
      if (totalEl) totalEl.textContent = String(pageCount);
    }

    function setActivePage(page) {
      page = Math.max(0, Math.min(pageCount - 1, page));
      activePage = page;
      if (currentEl) currentEl.textContent = String(page + 1);
    }

    function goToPage(page) {
      page = Math.max(0, Math.min(pageCount - 1, page));

      if (mode === 'desktop' && scrollTriggerInstance) {
        var progress = pageCount > 1 ? page / (pageCount - 1) : 0;
        var target = scrollTriggerInstance.start + progress * (scrollTriggerInstance.end - scrollTriggerInstance.start);
        window.scrollTo({ top: target, behavior: 'smooth' });
        return;
      }

      if (mode === 'mobile') {
        viewport.scrollTo({ left: page * viewport.clientWidth, behavior: 'smooth' });
        return;
      }

      setActivePage(page);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goToPage(activePage - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goToPage(activePage + 1);
      });
    }

    // ---- Mobile: native touch/swipe horizontal scroll with snap ----
    function onMobileScroll() {
      clearTimeout(mobileScrollTimeout);
      mobileScrollTimeout = setTimeout(function () {
        var width = viewport.clientWidth || 1;
        var page = Math.round(viewport.scrollLeft / width);
        setActivePage(page);
      }, 80);
    }

    var hasGsap = typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined';

    syncPanelHeight();
    window.addEventListener('resize', syncPanelHeight);

    if (!hasGsap || pageCount < 2) {
      // No GSAP, or nothing to page through: static grid, still keep panel height synced.
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    var mm = gsap.matchMedia();

    mm.add('(min-width: 990px)', function () {
      mode = 'desktop';
      section.setAttribute('data-split-scroll-ready', '');
      viewport.removeEventListener('scroll', onMobileScroll);
      setPageCountForMode(DESKTOP_ITEMS_PER_PAGE);

      syncPanelHeight();

      var headerEl = document.querySelector('.header-wrapper');
      var headerOffset = headerEl ? headerEl.offsetHeight : 0;

      var st = ScrollTrigger.create({
        trigger: section,
        start: 'top top+=' + headerOffset,
        end: function () {
          var scrollable = Math.max(track.scrollWidth - viewport.clientWidth, 0);
          return '+=' + Math.max(scrollable, window.innerHeight * 0.6);
        },
        pin: true,
        pinSpacing: true,
        scrub: 0.4,
        invalidateOnRefresh: true,
        snap: {
          snapTo: 1 / (pageCount - 1),
          duration: { min: 0.2, max: 0.5 },
          ease: 'power1.inOut',
        },
        onRefresh: syncPanelHeight,
        onUpdate: function (self) {
          var progress = self.progress;
          var scrollable = Math.max(track.scrollWidth - viewport.clientWidth, 0);
          gsap.set(track, { x: -scrollable * progress });
          setActivePage(Math.round(progress * (pageCount - 1)));
        },
      });

      scrollTriggerInstance = st;
      gsap.set(track, { x: 0 });
      setActivePage(0);

      return function () {
        st.kill();
        scrollTriggerInstance = null;
        section.removeAttribute('data-split-scroll-ready');
        gsap.set(track, { clearProps: 'transform' });
      };
    });

    mm.add('(max-width: 989px)', function () {
      mode = 'mobile';
      setPageCountForMode(MOBILE_ITEMS_PER_PAGE);
      gsap.set(track, { clearProps: 'transform' });
      section.removeAttribute('data-split-scroll-ready');
      setActivePage(0);
      viewport.scrollLeft = 0;
      viewport.addEventListener('scroll', onMobileScroll, { passive: true });

      return function () {
        viewport.removeEventListener('scroll', onMobileScroll);
      };
    });
  }

  function init() {
    var sections = document.querySelectorAll('[data-split-scroll]');
    sections.forEach(initSplitScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-split-scroll]');
    if (section) initSplitScroll(section);
  });
})();